module.exports = __webpack_public_path__ + "img/slogan_mobile.c5214682.png";